import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export const PlacementContentContainer = ({
  finalUrl,
  displayUrl,
  isClickDisabled,
  placementContentContainerClassName,
  children,
}) => {
  if (isClickDisabled) {
    return (
      <div className={classnames(placementContentContainerClassName, 'placement-card-content')}>
        {children}
      </div>
    );
  }
  return (
    <a
      className="placement-card-content"
      target="_blank"
      rel="noopener noreferrer"
      href={finalUrl || displayUrl}
    >
      {children}
    </a>
  );
};

PlacementContentContainer.propTypes = {
  finalUrl: PropTypes.string,
  displayUrl: PropTypes.string,
  isClickDisabled: PropTypes.bool,
  placementContentContainerClassName: PropTypes.string,
  children: PropTypes.node.isRequired,
};

PlacementContentContainer.defaultProps = {
  finalUrl: undefined,
  displayUrl: undefined,
  isClickDisabled: false,
  placementContentContainerClassName: undefined,
};
